import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  Flex,
  Heading,
  Box,
  Button,
} from '@chakra-ui/react';
import InputComSelect from '../../../components/common/inputComSelect';

import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import TabelaSecretaria from './tabela-secretaria/tabela-secretaria';
import * as api from '../../../api/secretarias';
import Paginacao from '../../../components/common/paginacao/paginacao';

const GerenciarSecretarias = () => {
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate()
  const [filtro, setFiltro] = useState<{ mode: "codigo" | "nome"; query: number | string | null }>({
    mode: "nome",
    query: "",
  });

  useEffect(() => {
    const controller = new AbortController();
    const fetchSecretarias = async () => {
      setLoading(true);
      try {
        const params: Record<string, string | number> = {};
        if (filtro.mode === "codigo" && filtro.query !== null && filtro.query !== "") {
          params.codSecretaria = Number(filtro.query);
        }
        if (filtro.mode === "nome" && typeof filtro.query === "string" && filtro.query.trim() !== "") {
          params.dscSecretaria = filtro.query.trim();
        }
  
        const data = await api.listarSecretarias(paginaAtual, itemsPerPage, params, { signal: controller.signal });
  
        if (data.formatoArquivos && data.formatoArquivos.length > 0) {
          setSecretarias(
            data.formatoArquivos.map((s: any) => ({
              codSecretaria: s.codSecretaria,
              dscSecretaria: s.dscSecretaria,
              numAtivo: s.numAtivo,
            }))
          );
        } else {
          setSecretarias([]);
        }
        setTotalPages(data.totalPaginas ?? 1);
      } catch (error: any) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          console.error("Erro ao buscar secretarias:", error);
        }
      } finally {
        setLoading(false);
      }
    };
  
    fetchSecretarias();
    return () => controller.abort();
  }, [paginaAtual, itemsPerPage, filtro]);
  

  const buscarSecretarias = ({ mode, query }: { mode: "codigo" | "nome"; query: number | string | null }) => {
    setFiltro({ mode, query });
    setPaginaAtual(1);
  };


  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Gerenciar Secretarias
      </Heading>

      <Flex
        w="100%"
        mt="40px"
        mb="20px"
        align="flex-start"
        justify="space-between"
        flexWrap="wrap"
        gap="16px"
      >
          <Button
            color="#fff"
            bgColor="#1789FC"
            _hover={{
              bgColor: "#1468C9"
            }}
            onClick={() => navigate('adicionar-secretaria')}
          >
            Adicionar Secretaria
          </Button>
          <Box flex="1" minW="280px">

          <InputComSelect onSearch={buscarSecretarias} debounceMs={400} />
          
        </Box>
      </Flex>

      <Box>
        <TabelaSecretaria 
          listaSecretaria={secretarias} 
          listaVazia="Nenhum dado disponível." 
          loading={loading}
          />
      </Box>

      <Paginacao 
        paginaAtual={paginaAtual} 
        totalPages={totalPages} 
        onPageChange={setPaginaAtual}
      />
    </Flex>
  )
}

export default GerenciarSecretarias
